import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

import { RatingScaleLabel } from './utils/ratingScales';

interface SkillSectionHeaderProps {
  isLanguageSection?: boolean;
  isMobile: boolean;
  labels: RatingScaleLabel[];
}

const SkillSectionHeader: React.FC<SkillSectionHeaderProps> = ({
  isLanguageSection,
  isMobile,
  labels,
}) => {
  const { t } = useTranslationWithPrefix('skillsAssessmentCollectedPage');

  if (isMobile) {
    return null;
  }

  return (
    <div
      className="hidden md:flex items-end gap-4 pl-4 lg:pl-6 pr-10 pt-4 pb-2 w-full"
      style={{
        backgroundColor: 'rgba(255,255,255,0.5)',
        borderBottom: '1px solid #eee',
      }}
    >
      <div className="flex-shrink-0" style={{ minWidth: '200px', width: '200px' }}>
        <span className="text-xs font-semibold uppercase tracking-wide" style={{ color: '#666' }}>
          {t('competence')}
        </span>
      </div>
      <div className="flex flex-1 justify-between h-6 px-3 relative">
        {labels.map((item, index) => {
          const isFirst = index === 0;
          const isLast = index === labels.length - 1;
          const offset = isFirst
            ? -50
            : isLast
              ? isLanguageSection
                ? -10
                : -40
              : isLanguageSection
                ? -5
                : -10;

          return (
            <span
              className="font-medium leading-tight whitespace-nowrap w-1"
              key={item.value}
              style={{
                color: isFirst ? '#666' : '#333',
                fontSize: '0.75rem',
                transform: `translateX(${offset}px)`,
              }}
            >
              {item.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default SkillSectionHeader;
